import { Record } from 'immutable';
import ErrorRecord from '~/data/ErrorRecord';

const keys: Fields = {
  isLoading: false,
  isModalOpen: false,
  error: undefined,
};

interface Fields {
  isLoading: boolean;
  isModalOpen: boolean;
  error?: ErrorRecord;
}

export default class SendDeletionRequestRecord extends Record<Fields>(keys) {
  setModalOpen(isModalOpen) {
    return this.set('isModalOpen', isModalOpen);
  }

  setLoading(isLoading) {
    return this.set('isLoading', isLoading);
  }
}
